import { useState, useCallback } from 'react';
import quarkusApi from '../../../../api/quarkusApi';

const authHeader = () => ({ headers: { Authorization: sessionStorage.getItem('token') } });

export function useAnamnesisV2() {
  const [isLoading, setLoading] = useState(false);

  const fetchByPatient = useCallback((patientId) => {
    setLoading(true);
    return quarkusApi
      .get(`/v2/anamnesis/patient/${patientId}`, authHeader())
      .finally(() => setLoading(false));
  }, []);

  const fetchQuestions = useCallback(() => {
    setLoading(true);
    return quarkusApi.get('/v2/anamnesis/questions', authHeader()).finally(() => setLoading(false));
  }, []);

  return { fetchByPatient, fetchQuestions, isLoading };
}
